var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRectangle43542(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 317,
    viewBox: "0 0 286 317",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.245239 7.97936C0.245239 3.89796 3.55387 0.589355 7.63527 0.589355H278.573C282.898 0.589355 286.299 4.28708 285.937 8.59695L262.645 286.342C262.347 289.904 259.541 292.742 255.982 293.081L8.33592 316.666C3.99734 317.08 0.245239 313.668 0.245239 309.31V7.97936Z",
    fill: "url(#paint0_linear_2514_42871)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63527 1.20124H278.573C282.54 1.20124 285.659 4.5928 285.328 8.54582L262.036 286.291C261.762 289.558 259.188 292.161 255.924 292.472L8.2779 316.057C4.29856 316.436 0.857127 313.307 0.857127 309.31V7.97936C0.857127 4.2359 3.8918 1.20124 7.63527 1.20124Z",
    stroke: "#FFFBFB",
    strokeOpacity: 0.2,
    strokeWidth: 1.22378
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2514_42871",
    x1: 0.245239,
    y1: 159.013,
    x2: 286.609,
    y2: 159.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B79891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94716B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle43542);
export default __webpack_public_path__ + "static/media/rectangle-43542.b89ef6f51d5a9f582ebe862c47edd963.svg";
export { ForwardRef as ReactComponent };